import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { SkinsListComponent } from '@core/components/skins-list/skins-list.component';
import { DecimalPipe } from '@angular/common';
import { ContextMenuService } from '@core/services/context-menu.service';
import { ClipboardService } from '@core/services/clipboard.service';
import {
  KingHistory,
  KingSkin,
  KingUser,
} from '@features/games/king/interfaces/king.interface';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { isEmptySeatPlaceholder, isMenuless } from '@core/utils/bot-player.util';

@Component({
  selector: 'app-king-skins-modal',
  imports: [
    SkinsListComponent,
    BalanceIconComponent,
    DecimalPipe,
    PlayerRowComponent,
  ],
  templateUrl: './king-skins-modal.component.html',
  styleUrl: './king-skins-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class KingSkinsModalComponent {
  public sessionService = inject(SessionService);
  public contextMenuService = inject(ContextMenuService);
  public clipboardService = inject(ClipboardService);
  protected readonly isMenuless = isMenuless;

  readonly kingGame =
    input.required<
      Pick<KingHistory, 'roundid' | 'gameid' | 'winner' | 'king' | 'part'>
    >();
  readonly skins = input.required<KingSkin[]>();
  readonly totalValue = input.required<number>();

  readonly winner = computed<KingUser | undefined>(() => {
    const game = this.kingGame();

    if (
      game.king.steamid === game.winner.steamid ||
      isEmptySeatPlaceholder(game.winner)
    ) {
      return game.king;
    } else {
      return game.part;
    }
  });
}
